import { Injectable } from '@angular/core'
import {
    InvitationServiceAcceptAssetOwnerInvitationGQL,
    InvitationServiceAcceptBrandBusinessOwnerInvitationGQL,
    InvitationServiceAcceptPmcBusinessOwnerInvitationGQL,
    InvitationServiceAcceptStaffMemberInvitationGQL,
    InvitationServiceAcceptTermsGQL,
    InvitationServiceAcceptTravelAgentBusinessOwnerInvitationGQL,
    InvitationServiceAssetOwnerInvitationSummaryGQL,
    InvitationServiceBrandBusinessOwnerInvitationStatusGQL,
    InvitationServiceInvitationStatusGQL,
    InvitationServicePmcBusinessOwnerInvitationStatusGQL,
    InvitationServiceStaffMemberInvitationSummaryGQL,
    InvitationServiceTravelAgentBusinessOwnerInvitationStatusGQL,
    InvitationServiceUpdatePhoneGQL,
    Role
} from '../../graphql'

@Injectable({
    providedIn: 'root'
})
export class InvitationService {

    constructor(
        public _acceptTermsGQL: InvitationServiceAcceptTermsGQL,
        public _updatePhoneGQL: InvitationServiceUpdatePhoneGQL,
        public _invitationStatusGQL: InvitationServiceInvitationStatusGQL,
        private _acceptAssetOwnerInvitationGQL: InvitationServiceAcceptAssetOwnerInvitationGQL,
        private _acceptBrandBusinessOwnerInvitationGQL: InvitationServiceAcceptBrandBusinessOwnerInvitationGQL,
        private _acceptPmcBusinessOwnerInvitationGQL: InvitationServiceAcceptPmcBusinessOwnerInvitationGQL,
        private _acceptStaffMemberInvitationGQL: InvitationServiceAcceptStaffMemberInvitationGQL,
        private _acceptTravelAgentBusinessOwnerInvitationGQL: InvitationServiceAcceptTravelAgentBusinessOwnerInvitationGQL,
        private _assetOwnerInvitationSummaryGQL: InvitationServiceAssetOwnerInvitationSummaryGQL,
        private _brandBusinessOwnerInvitationStatusGQL: InvitationServiceBrandBusinessOwnerInvitationStatusGQL,
        private _pmcBusinessOwnerInvitationStatusGQL: InvitationServicePmcBusinessOwnerInvitationStatusGQL,
        private _staffMemberInvitationSummaryGQL: InvitationServiceStaffMemberInvitationSummaryGQL,
        private _travelAgentBusinessOwnerInvitationStatusGQL: InvitationServiceTravelAgentBusinessOwnerInvitationStatusGQL,
    ) {
    }

    roleKeysByInvitationRole(invitationRole: Role, invitationId: string, assetId: string): RoleKeys {
        if (invitationRole === Role.TravelAgentBusinessOwner) {
            return {
                invitation: 'travelAgentBusinessOwnerInvitation',
                accept: 'acceptTravelAgentBusinessOwnerInvitation',
                acceptCommand: { invitationId }
            } as RoleKeys
        }
        else if (invitationRole === Role.PmcBusinessOwner) {
            return {
                invitation: 'pmcBusinessOwnerInvitation',
                accept: 'acceptPmcBusinessOwnerInvitation',
                acceptCommand: { invitationId }
            } as RoleKeys
        }
        else if (invitationRole === Role.BrandBusinessOwner) {
            return {
                invitation: 'brandBusinessOwnerInvitation',
                accept: 'acceptBrandBusinessOwnerInvitation',
                acceptCommand: { invitationId }
            } as RoleKeys
        } else if (invitationRole === Role.Owner) {
            return {
                invitation: 'assetOwnerInvitationSummary',
                accept: 'acceptAssetOwnerInvitation',
                acceptCommand: {
                    input: {
                        invitationId,
                        assetId
                    }
                }
            } as RoleKeys
        }
        else {
            return {
                shortRoleName: 'StaffMember',
                invitation: 'staffMemberInvitationSummary',
                accept: 'acceptStaffMemberInvitation',
                acceptCommand: { input : { invitationId }}
            } as RoleKeys
        }
    }

    configureQueriesForRole(role: Role) {
        switch (role) {
            case Role.BrandBusinessOwner: return {
                validateInvitation: this._brandBusinessOwnerInvitationStatusGQL,
                acceptInvitation: this._acceptBrandBusinessOwnerInvitationGQL,
            }
            case Role.PmcBusinessOwner: return {
                validateInvitation: this._pmcBusinessOwnerInvitationStatusGQL,
                acceptInvitation: this._acceptPmcBusinessOwnerInvitationGQL,
            }
            case Role.TravelAgentBusinessOwner: return {
                validateInvitation: this._travelAgentBusinessOwnerInvitationStatusGQL,
                acceptInvitation: this._acceptTravelAgentBusinessOwnerInvitationGQL,
            }
            case Role.Owner: return {
                validateInvitation: this._assetOwnerInvitationSummaryGQL,
                acceptInvitation: this._acceptAssetOwnerInvitationGQL,
            }
            case Role.TravelAgent:
            case Role.PmcAgent:
            case Role.BrandAgent:
                return {
                    validateInvitation: this._staffMemberInvitationSummaryGQL,
                    acceptInvitation: this._acceptStaffMemberInvitationGQL,
                }
                default: throw new Error('Unknown role')
        }
    }
}

export interface RoleKeys {
    invitation: string,
    accept: string,
    acceptCommand: any
}

export interface GqlQueries {
    validateInvitation: any,
    acceptInvitation: any,
}

